import { render } from "./CompanyAddModal.vue?vue&type=template&id=3d117551"
import script from "./CompanyAddModal.vue?vue&type=script&lang=js"
export * from "./CompanyAddModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__